<template>
    <div class="layout__container layout__overflow-hidden" v-on:drop.prevent>
        <div class="layout__padding-clear">
            <div class="layout__width-400px layout__padding-clear" v-show="upload">
                <!--<div>-->

                <div class="text__align-center layout__margin__bottom-6px">

                    <img class="component__upload-cloud" src="https://rpsassets.blob.core.windows.net/rpsimages/images/icons/uploadIcon.png"><br>

                    <h2 class="text__colour-teal layout__margin__top-10">Artwork Upload</h2>

                    <p class="layout__margin__top-10">Upload your pdf to view a preview</p>

                </div>

                <div class="component__upload-portal__leading-dropzone colour__background-white" id="dropzone"
                     @dragover.prevent="ondrag" @drop="ondrop" @dragleave="onleave" v-show="showUploadBool">
                    <h3 class="text__colour-teal text__align-center text__style-bold-900">Drag and drop<br>your
                        pdf here</h3>

                    <el-button class="button-red layout__margin-2-05 button__base layout__margin__top-10"
                               v-on:click="showUpload">Or
                        click to upload
                    </el-button>
                </div>

                <div class="layout__position-center" id="progress" v-show="showProgressBool">
                    <div class="layout__width-126px layout__height-126px layout__padding-clear layout__margin__top-20px">
                        <el-progress class="layout__position__absolute" type="circle" :width="126" status="exception"
                                     :percentage="uploadPercentage" color="#00859c"></el-progress>
                        <img class="component__upload-progress__icon__leading layout__position__absolute"
                             src="https://rpsassets.blob.core.windows.net/rpsimages/images/images/instantPrint/preview.png">
                    </div>
                </div>

                <div id="typeError" v-show="showErrorBool" class="text__align-center">
                    <h1 class="text__colour-red icon-error"></h1>
                    <h4>There's a problem!</h4>
                    <p>Attempting to upload unsupported file types:</p>
                    <div v-for="(errorFile) in fileErrors" v-bind:key="errorFile">
                        <p>{{errorFile}}</p>
                    </div>
                    <br>
                    <p class="text__colour-teal">Supported file type:<br> .pdf</p><br>
                    <el-button class="button-red button__base" v-on:click="tryAgain()">Try again</el-button>
                </div>
                <div id="uploadError" v-show="showUploadErrorBool" class="text__align-center">
                    <h1 class="text__colour-red icon-error"></h1>
                    <h4>There's a problem!</h4><br>
                    <h3>Uploading Error, please try again</h3><br>
                    <el-button class="button-red layout__padding-10px button__base" v-on:click="tryAgain()">
                        Try again
                    </el-button>
                </div>
                <!--</div>-->

                <input type="file" id="leadFiles" ref="leadFiles"
                       v-on:change="buttonUpload()" multiple v-show=false>
            </div>

            <div v-show="preview" class="layout__padding-2-4">

                <h3 class="text__colour-teal text__align-center">Artwork Preview</h3>

                <div class="layout__padding-clear text__align-center">
                    <el-radio-group v-model="activeThumbnails" v-for="(artwork, index) in uploadedFiles" :max="1" class="layout__margin-20-0">
                        <el-radio-button class="layout__width-40px layout__border__all-2px-f4f4f4 layout__padding-10-0" :label="index" :key="'index'">{{index + 1}}</el-radio-button>
                    </el-radio-group>
                </div>



                <div v-for="(artwork, index) in uploadedFiles" class="layout__padding-clear layout__overflow-hidden">
                    <div class="layout__width-100 layout__padding-clear layout__overflow-hidden">
                        <carousel :per-page="3" :autoplayTimeout="6000" :autoplay="true" :paginationSize="20"
                                  paginationActiveColor="#00859c" :loop="true" v-show="activeThumbnails === index">
                            <slide class="layout__padding-clear layout__overflow-hidden"
                                   v-for="(thumbnail, index) in artwork.thumbs">
                                <div class="layout__margin__bottom-25px layout__padding__right-20px">
                                    <img class="layout__width-100 layout__border__all-1px-grey"
                                         v-bind:src=thumbnail>
                                    <span class="layout__padding-20-0">Page {{index + 1}}</span>
                                </div>
                            </slide>
                        </carousel>
                    </div>
                </div>

                <div class="layout__padding-clear">
                    <el-button class="button__base__admin layout__position-left button-teal" v-on:click="tryAgain()">
                        Upload
                        New Artwork
                    </el-button>
                    <el-button class="button__base__admin layout__position-right button-red"
                               v-on:click="addArtworkToOrder()">Add Artwork to Order
                    </el-button>
                </div>
            </div>

        </div>
    </div>

</template>

<script>
    import Axios from 'axios';
    import {axios} from '@/mixins/Axios.js';
    import {Carousel, Slide} from 'vue-carousel';

    export default {
        name: "customers",
        mixins: [axios],
        props: {
            bespokeOrder: {},
            bespokeOrderItem: {},
            artwork: Array
        },
        components: {
            Carousel,
            Slide
        },
        data() {
            return {
                order: {},
                index: '',
                showUploadBool: true,
                showProgressBool: false,
                showErrorBool: false,
                showUploadErrorBool: false,
                fileUploading: '',
                fileUploadingProgress: '',
                fileErrors: [],
                leadFiles: [],
                filename: '',
                uploadedFiles: [],
                uploadPercentage: 0,
                fileLocation: '',
                upload: true,
                preview: false,
                activeThumbnails: 0
            }
        },
        computed: {},
        created() {
            console.log(this.upload)
            console.log(this.preview)
        },
        methods: {
            tryAgain() {
                this.showUploadBool = true;
                this.showErrorBool = false;
                this.showProgressBool = false;
                this.showUploadErrorBool = false;
                this.fileErrors = []
                // this.leadFiles = []
                this.upload = true;
                this.preview = false;
                this.uploadPercentage = 0;
                this.activeThumbnails = 0;
            },
            ondrag() {
                document.getElementById('dropzone').className = 'component__upload-portal__leading-dropzone dragover';
                // event.preventDefault(); // just opening the file
                return false;

            },

            onleave() {
                console.log('on leave')
                document.getElementById('dropzone').className = 'component__upload-portal__leading-dropzone';
                // event.preventDefault(); // just opening the file
                return false;
            },

            ondrop(event) {
                console.log('onDrop')
                event.stopPropagation();
                event.preventDefault();

                console.log('making post to api')
                console.log(this.job)

                this.leadFiles = event.dataTransfer.files

                this.onUpload();
                document.getElementById('dropzone').className = 'component__upload-portal__leading-dropzone';
            },

            showUpload() {
                document.getElementById('leadFiles').click()
            },
            buttonUpload() {
                console.log('making post to api')
                console.log(this.job)

                this.leadFiles = this.$refs.leadFiles.files;

                console.log(this.leadFiles)
                this.onUpload();

            },
            onUpload() {
                let formData = new FormData();

                formData.append("SOURCE", "BESPOKE");
                for (let i = 0; i < this.leadFiles.length; i++) {
                    const file = this.leadFiles[i];
                    const fileType = file.type

                    if (fileType !== "application/pdf") {
                        console.log('file doesnt match')
                        this.fileErrors.push(file.name)
                    } else {
                        console.log('file does match')
                        formData.append(file.name, file, file.name);
                    }
                }

                if (this.fileErrors.length === 0) {
                    console.log('file does match')
                    this.showUploadBool = false;
                    this.showErrorBool = false;
                    this.showUploadErrorBool = false;
                    this.showProgressBool = true;

                    this.postFile(formData)
                } else {
                    this.showUploadBool = false;
                    this.showErrorBool = true;
                    this.showProgressBool = false;
                    this.showUploadErrorBool = false;
                    formData = new FormData();
                }
            },
            postFile(formData) {
                // todo need to update the endpoint
                this.filename = this.leadFiles[0].name
                const uploadFile = `${process.env.VUE_APP_UPLOADAPIHOST}/api/upload`

                Axios.post(uploadFile, formData, {

                    headers: {
                        "content-type": "multipart/form-data",
                        "Access-Control-Allow-Origin": "*",
                        "Authorization": "Bearer " + this.returnCookie("_token")
                    },
                    onUploadProgress: function (uploadEvent) {
                        this.uploadPercentage = Math.round(uploadEvent.loaded / uploadEvent.total * 100);
                    }.bind(this)
                })
                    .then(response => {
                        console.log(response)

                        console.log(response.data.length)
                        this.preview = true;

                        for (let i = 0; i < response.data.length; i++) {
                            this.uploadedFiles[i] = response.data[i]
                        }

                        this.$refs.leadFiles.value = ''; // fixme-Rifat this line might cause issues with the addArtworkToOrder method as it using leadFiles.length might be direct ref to this.$refs.leadFiles
                        console.log(this.uploadedFiles)

                        this.upload = false;
                    })
                    .catch(error => {
                        console.log(error)
                        this.$refs.leadFiles.value = ''; // resets the upload - will resolve the bug about reloading a file x2
                        this.showUploadBool = false;
                        this.showErrorBool = false;
                        this.showProgressBool = false;
                        this.showUploadErrorBool = true;
                        this.leadFiles = [];
                    })


            },
            addArtworkToOrder() {

                for (let i = 0; i < this.leadFiles.length; i++) {
                    // const file = this.leadFiles[i];

                    const fileOrder = {
                        code: this.bespokeOrder.code,
                        type: "PRODUCTION FILE",
                        source: "ORDER ADMIN",
                        sourceId: this.bespokeOrderItem.orderId,
                        url: this.uploadedFiles[i].storageUri,
                        filename: this.uploadedFiles[i].originalName,
                    }
                    console.log(fileOrder)

                    const postFile = `${process.env.VUE_APP_ACCOUNTSAPIHOST}/api/services/app/BespokeFiles/Create`

                    Axios.post(postFile, fileOrder, this.returnHeaderUsingToken())
                        .then(response => {


                            console.log(response)

                            // this.getAllOrderItems()
                            // todo call the get updated object button

                            // updateOrderInformation

                            this.tryAgain()

                            document.getElementById('updateOrderInformation').click()
                            document.getElementById('closeUpload').click()

                            // todo

                            // const getArtwork = `https://testtkaccountsapi.azurewebsites.net/api/services/app/BespokeFiles/GetAllBySourceIdAsync?sourceid=` + this.bespokeOrderItem.orderId
                            // console.log(getArtwork)
                            // Axios.get(getArtwork, this.returnHeaderUsingToken())
                            //     .then(response => {
                            //         console.log(response)
                            //         this.$parent.artwork = response.data.result
                            //     })
                        })
                        .catch(error => {
                        })
                }
            }
        }
    };
</script>
